import { $t } from "@/plugins/i18n";
import { speechLibrary } from "@/router/enums";
import sound from "@/assets/svg/sound.svg?component";
export default {
  path: "/clonedVoiceLib",
  redirect: "/clonedVoiceLib/index",
  meta: {
    icon: sound,
    title: $t("menus.speechLibrary"), // 建议多语言
    rank: speechLibrary
  },
  children: [
    {
      path: "/clonedVoiceLib/index",
      name: "clonedVoiceLib",
      component: () => import("@/views/clonedVoiceLib/index.vue"),
      meta: {
        title: $t("menus.speechLibrary"),
        showLink: false
        // keepAlive: false
      }
    }
  ]
} satisfies RouteConfigsTable;
